import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-ds-data-table',
  standalone: false,
  template: `
    <section class="ds-card">
      <ng-content select="[dsTableHeader]"></ng-content>
      @if (loading) {
        <div class="ds-overlay">
          <div class="spinner-border"></div>
        </div>
      } @else if (error) {
        <div class="px-4 py-4 text-danger">{{ error }}</div>
      } @else {
        <ng-content></ng-content>
      }
    </section>
  `,
})
export class DsDataTable {
  @Input() loading = false;
  @Input() error: string | null = null;
}
